import type { Resources } from './en';

/** Bulgarian UI text. Mirrors `en.ts` key for key (the type and a test enforce it). */
export const bg: Resources = {
  common: {
    actions: 'Действия',
    cancel: 'Отказ',
    close: 'Затвори',
    dismiss: 'Скрий',
    loading: 'Зареждане',
    more: 'Още действия',
    save: 'Запази',
  },
  form: {
    required: 'Задължително.',
    notANumber: 'Въведете число.',
  },
  errors: {
    generic: 'Нещо се обърка. Опитайте отново.',
    appFailed: 'Botimir спря да работи',
    appFailedBody: 'Презаредете страницата, за да продължите. Нищо запазено не е изгубено.',
    reload: 'Презареди',
    pageFailed: 'Страницата не се зареди',
    pageFailedBody: 'Опитайте отново. Ако продължава, презаредете приложението.',
    tryAgain: 'Опитай отново',
  },
  serverErrors: {
    price_not_positive: 'Цената на дял трябва да е над нула.',
    sum_not_positive: 'Началната сума трябва да е над нула.',
    sum_too_small: 'Началната сума не стига за нито един дял.',
    levels_range: 'Нивата трябва да са между 1 и 6.',
    step_range: 'Стъпката трябва да е между 1% и 50%.',
    multiplier_range: 'Множителят трябва да е между 1 и 4.',
    target_range: 'Целта трябва да е между 0,1% и 100%.',
    tick_invalid: 'Ценовата стъпка трябва да е над 0 и най-много 1.',
    not_positive: 'Трябва да е над нула.',
    whole_shares: 'Използвайте цели дялове.',
    share_decimals: 'Използвайте най-много 4 знака след десетичната запетая.',
    time_zone_missing: 'Посочете часова зона.',
    time_future: 'Времето на изпълнение не може да е в бъдещето.',
    time_before_open: 'Времето на изпълнение не може да е преди отварянето на позицията.',
    isin_invalid: 'Въведете ISIN от 12 знака, например IE00B5BMR087.',
    symbol_invalid: 'Въведете пазарен символ, например SXR8.DE.',
    signal_invalid: 'Въведете пазарен символ, например ^GSPC.',
    name_required: 'Въведете името на инструмента.',
    isin_taken: 'Този ISIN вече е в списъка.',
    symbol_taken: 'Този символ вече е в списъка.',
    instrument_not_found: 'Инструментът не е намерен.',
    instrument_in_use: 'Инструментът има позиции. Деактивирайте го.',
    instrument_inactive: 'Инструментът е неактивен.',
    position_not_found: 'Позицията не е намерена.',
    position_not_open: 'Позицията вече не е отворена.',
    level_not_found: 'Нивото не е намерено.',
    level_closed: 'Нивото вече е купено или пропуснато.',
    fill_not_found: 'Покупката не е намерена.',
    fill_not_removable: 'Могат да се премахват само покупки по стълбата. Откажете позицията.',
    alert_not_found: 'Сигналът не е намерен.',
    alert_not_open: 'Само отворени сигнали могат да се скрият.',
    notes_too_long: 'Бележките са до 5000 знака.',
    email_missing: 'Първо добавете имейл за известия.',
    bad_credentials: 'Грешен имейл или парола.',
    rate_limited: 'Твърде много опити. Опитайте по-късно.',
    sign_in_required: 'Влезте, за да продължите.',
    csrf: 'Сесията ви се промени. Презаредете страницата.',
    invalid_value: 'Въведете валидна стойност.',
    not_found: 'Не е намерено.',
    server: 'Нещо се обърка. Опитайте отново.',
    network: 'Мрежова грешка. Проверете връзката си.',
    symbol_unknown: 'Няма пазарни данни за този символ. Проверете го в Yahoo Finance.',
    chart_duplicate: 'Символ присъства два пъти в таблото.',
    charts_too_many: 'Таблото побира до 24 графики.',
    market_unavailable: 'Пазарните данни не са достъпни в момента. Опитайте след минута.',
  },
  session: {
    signOut: 'Изход',
  },
  home: {
    eyebrow: 'S&P 500 · Nasdaq-100 · Xetra',
    headline: 'План за всеки спад.',
    headline2: 'Продайте, когато си струва.',
    lead: 'Botimir планира стълба от покупки за европейски ETF-и върху S&P 500 и Nasdaq-100, следи Xetra на всеки пет минути и ви пише, когато е време да купите ниво или да продадете всичко на целта.',
    example: 'Пример: начални 1000 €, нива през 10%, двойно повече дялове на всяко ниво, цел 5%.',
    stepsTitle: 'Как работи',
    plan: 'Планирайте стълбата',
    planBody:
      'Въведете цената и сумата, с която започвате. Вижте всяко ниво, размера му и капитала, който ще ви трябва, ако се купят всички.',
    watch: 'Оставете го да следи',
    watchBody:
      'Котировки на всеки пет минути, докато Xetra е отворена, с пазарния режим за контекст. Никога не се пускат поръчки вместо вас.',
    act: 'Действайте по имейла',
    actBody:
      'Съобщение, когато се достигне ниво или целта, с лимитна цена и най-доброто време за сделка. Запишете какво направихте за секунди.',
    links: 'Проучване',
    copyright: 'Botimir © {{year}}',
  },
  signIn: {
    title: 'Вход',
    body: '',
    email: 'Имейл',
    password: 'Парола',
    submit: 'Вход',
    missing: 'Въведете имейл и парола.',
  },
  nav: {
    label: 'Основна навигация',
    positions: 'Позиции',
    alerts: 'Сигнали',
    stats: 'Статистика',
    charts: 'Графики',
    watchlist: 'Списък за наблюдение',
    settings: 'Настройки',
  },
  shell: {
    toggleSidebar: 'Покажи или скрий страничния панел',
    toggleInspector: 'Покажи или скрий панела с детайли',
    breadcrumb: 'Път',
    search: 'Търсене',
    notifications: 'Известия',
    details: 'Детайли за позицията',
  },
  market: {
    open: '{{exchange}} е отворена',
    closed: '{{exchange}} е затворена',
    closesAt: 'Затваря в {{time}}',
    opensAt: 'Отваря в {{time}}',
  },
  marketStrip: {
    label: 'Пазар',
    fromHigh: '{{drawdown}} от върха',
  },
  regime: {
    uptrend: 'Възходящ',
    downtrend: 'Низходящ',
    uptrendLower: 'възходящ',
    downtrendLower: 'низходящ',
    trendHint:
      'Затваряне спрямо 200-дневната средна, потвърдено с 3 затваряния. Дни в текущия тренд.',
    volatilityHint: '20-дневна реализирана волатилност, на годишна база.',
    volLower: {
      calm: 'спокоен',
      normal: 'нормален',
      stressed: 'напрегнат',
    },
    vol: {
      calm: 'Спокоен',
      normal: 'Нормален',
      stressed: 'Напрегнат',
    },
  },
  analogs: {
    loading: 'Преглеждаме минали стълби като тази…',
    sentence:
      'При условия като днешните ({{conditions}}): {{level2}} от миналите стълби стигнаха ниво 2, {{all}} изискаха пълната сума. Медиана {{median}} борсови дни до целта; най-лошо {{worst}}.',
    anyConditions: 'всички условия',
    caveat:
      'Въз основа на {{entries}} припокриващи се исторически входа за {{years}} години; малко независими епизода.',
  },
  positions: {
    new: 'Нова позиция',
    emptyTitle: 'Няма отворени позиции',
    emptyBody:
      'Отворете позиция, когато купите. Botimir планира стълбата и ви пише кога да действате.',
    keyboardHint: 'Преминаване, отваряне и запис с',
  },
  positionCard: {
    label: 'Позиция {{symbol}}',
    invested: 'Вложени {{amount}}',
    atTarget: 'На целта',
    buyDue: 'Време за покупка',
    toLevel: '{{distance}} до Н{{n}}',
    toTarget: '{{distance}} до целта',
    summary:
      '{{shares}} дяла · средна {{average}} · цел {{target}} · още {{remaining}} за оставащите нива',
  },
  ladderTrack: {
    label: 'Стълба: цена {{current}}, цел {{target}}, купени {{filled}} от {{total}} нива',
  },
  ladder: {
    level: 'Ниво',
    levelN: 'Ниво {{n}}',
    entry: 'Вход',
    entryShort: 'Вход',
    price: 'Цена',
    trigger: 'Цена за покупка',
    shares: 'Дялове',
    cost: 'Сума',
    cumulative: 'Натрупано',
    targetIfFilled: 'Цел при покупка',
    status: 'Статус',
    fill: 'Изпълнение',
    target: 'Цел',
    buy: 'Покупка',
    sell: 'Продажба',
    statuses: {
      pending: 'Чака',
      triggered: 'Купи сега',
      filled: 'Купено',
      skipped: 'Пропуснато',
    },
  },
  position: {
    status: {
      open: 'Отворена',
      target_reached: 'Продай всичко',
      closed: 'Затворена',
      cancelled: 'Отказана',
      buy_one: 'Купи {{count}} ниво',
      buy_other: 'Купи {{count}} нива',
    },
    invested: 'Вложени',
    marketValue: 'Пазарна стойност',
    proceeds: 'Постъпления',
    pl: 'Печалба/загуба',
    toTarget: 'Цел',
    shares: 'Дялове',
    sharesAt: '{{shares}} дяла по {{average}}',
    lastPrice: '{{price}} · {{time}}',
    noQuote: 'Още няма котировка',
    targetReached: 'Достигната',
    away: 'на {{distance}}',
    targetOf: '{{target}} върху общата сума',
    newAverage: 'Нова средна',
    newTarget: 'Нова цел',
    ladder: 'Стълба',
    recordFill: 'Запиши покупка',
    recordFillShort: 'Запиши',
    recordFillLevel: 'Запиши покупка за ниво {{n}}',
    editTarget: 'Промени целта',
    close: 'Затвори позицията',
    cancel: 'Откажи позицията',
    cancelTitle: 'Да се откаже ли позицията?',
    cancelBody: 'За позиция, отворена по грешка. Не влиза в статистиката и спира всички сигнали.',
    skip: 'Пропусни нивото',
    skipLevel: 'Пропусни ниво {{n}}',
    skipTitle: 'Да се пропусне ли ниво {{n}}?',
    skipBody: 'Botimir спира сигналите за това ниво. Другите нива остават по план.',
    undoFill: 'Отмени покупката',
    undoFillLevel: 'Отмени покупката на ниво {{n}}',
    undoTitle: 'Да се отмени ли покупката на ниво {{n}}?',
    undoBody: 'Нивото отново чака, а средната цена и целта се преизчисляват.',
    priceChart: 'Цена',
    priceChartLabel:
      'Дневни затваряния на {{symbol}} за последните шест месеца с нивата на стълбата и целта',
    sixMonths: 'Последните 6 месеца',
    regime: 'Пазарен режим',
    atEntry: 'При входа',
    now: 'Сега',
    age: 'Възраст',
    sessions_one: '{{count}} сесия',
    sessions_other: '{{count}} сесии',
    ageLine: 'Ден {{day}} · медиана {{median}} · p90 {{p90}}',
    regimeCaveat:
      'Режимът описва пазара, не го предсказва. Медианите са от минали стълби с вашите настройки.',
    alerts: 'Сигнали',
    notes: 'Бележки',
    notesPlaceholder: 'Защо я отворихте, какво очаквате…',
    notFound: 'Позицията не е намерена',
  },
  openPosition: {
    title: 'Нова позиция',
    description: 'Запишете първата покупка. Botimir планира стълбата от нея.',
    instrument: 'Инструмент',
    pickInstrument: 'Изберете инструмент',
    price: 'Цена на дял',
    priceHint: 'Цената, на която купихте. Попълнена е с последната котировка.',
    initialSum: 'Начална сума',
    target: 'Целева печалба',
    ladderSettings: 'Настройки на стълбата',
    ladderSummary: '{{levels}} нива · през {{step}}% · ×{{multiplier}} дяла',
    levels: 'Нива',
    step: 'Стъпка',
    stepHint: 'Всяко ниво е с толкова по-ниско от предишното.',
    multiplier: 'Множител',
    multiplierHint: 'Всяко ниво купува толкова пъти повече дялове от предишното.',
    plan: 'План',
    planEmpty: 'Въведете цена и начална сума, за да видите стълбата.',
    capitalNeeded: 'Нужен капитал, ако се купят всички нива',
    leftover: '{{shares}} дяла; {{leftover}} от началната сума остават невложени.',
    submit: 'Отвори позиция',
    opened: 'Позицията в {{symbol}} е отворена.',
  },
  recordFill: {
    title: 'Запис на покупка · {{symbol}}',
    description: 'Какво точно купихте. Следващите нива запазват планираните си цени.',
    level: 'Ниво',
    price: 'Цена',
    shares: 'Дялове',
    executedAt: 'Изпълнена на',
    submit: 'Запиши покупката',
    recorded: 'Ниво {{n}} е записано.',
  },
  closePosition: {
    title: 'Затваряне на позиция · {{symbol}}',
    description: 'Запишете продажбата на всички дялове.',
    price: 'Продажна цена',
    shares: 'Дялове',
    executedAt: 'Изпълнена на',
    proceeds: 'Постъпления',
    result: 'Резултат',
    target: 'Целева цена {{price}}',
    submit: 'Затвори позицията',
    closed: 'Позицията в {{symbol}} е затворена.',
  },
  editTarget: {
    title: 'Промяна на целта',
    description: 'Печалбата върху общата вложена сума.',
    saved: 'Целта е обновена.',
  },
  alerts: {
    filter: 'Покажи',
    open: 'Отворени',
    all: 'Всички',
    emptyOpen: 'Няма какво да се прави',
    emptyAll: 'Още няма сигнали',
    emptyBody: 'Botimir записва сигнал и ви пише, когато се достигне ниво или целта.',
    levelHit: 'Купи ниво {{n}} на {{symbol}} на или под {{price}}',
    targetHit: 'Продай всички {{symbol}} на или над {{price}}',
    marketOpen: 'Xetra отвори без отворена позиция',
    regimeChange: '{{symbol}}: трендът стана {{trend}}',
    positionLink: '{{symbol}} №{{id}}',
    recordFill: 'Запиши покупка',
    recordSale: 'Запиши продажба',
    dismiss: 'Скрий',
    statuses: {
      open: 'Отворен',
      done: 'Изпълнен',
      dismissed: 'Скрит',
      info: 'Информация',
    },
  },
  stats: {
    summary: 'Обобщение',
    realized: 'Реализирана печалба',
    maxDeployed: 'Най-много вложени {{amount}}',
    xirr: 'Годишна доходност',
    xirrHint: 'Претеглена с потоците',
    medianDays: 'Медиана на държане',
    calendarDays: 'Календарни дни',
    closed: 'Затворени позиции',
    vsBuyHold: 'спрямо „купи и задръж“',
    benchmark: '„Купи и задръж“ {{rate}}',
    noBenchmark: 'Няма достатъчно ценова история',
    cumulativePl: 'Натрупана реализирана печалба',
    cumulativePlLabel: 'Натрупана реализирана печалба и загуба във времето',
    deployed: 'Вложен капитал',
    deployedLabel: 'Капитал, вложен в позиции, във времето',
    notEnoughPoints: 'Още няма достатъчно данни за графика.',
    closedPositions: 'Затворени позиции',
    annualisedHidden: 'Показва се при държане от поне 30 дни.',
    emptyTitle: 'Още няма затворени позиции',
    emptyBody: 'Статистиката се появява, след като затворите позиция.',
    cols: {
      opened: 'Отворена',
      closed: 'Затворена',
      symbol: 'Символ',
      deepest: 'Най-дълбоко',
      shares: 'Дялове',
      invested: 'Вложени',
      average: 'Средна',
      closePrice: 'Продажна цена',
      proceeds: 'Постъпления',
      pl: 'Печалба',
      plPct: 'Печалба %',
      days: 'Дни',
      annualised: 'Годишно',
      regime: 'Режим при входа',
    },
  },
  charts: {
    edit: 'Редактирай символите',
    emptyTitle: 'Още няма графики',
    emptyBody:
      'Добавете произволен символ от Yahoo Finance: индекси като ^GSPC, ETF като SXR8.DE, валути като EURUSD=X.',
    periods: {
      '1d': '1Д',
      '5d': '5Д',
      '1mo': '1М',
      '6mo': '6М',
      ytd: 'ОНГ',
      '1y': '1Г',
      '5y': '5Г',
      max: 'Макс',
    },
    periodFor: 'Период за {{symbol}}',
    chartLabel: 'Ценова графика на {{symbol}}, {{period}}',
    tableCaption: 'Цени на {{symbol}}, {{period}}',
    dayChange: '{{value}} днес',
    periodChange: '{{value}} за {{period}}',
    reset: 'Покажи целия период',
    showLine: 'Покажи като линия',
    showCandles: 'Покажи като свещи',
    date: 'Дата',
    close: 'Затваряне',
    retry: 'Опитай пак',
    viewAsTable: 'Покажи като таблица',
    viewAsChart: 'Покажи като графика',
    legend: { open: 'О', high: 'В', low: 'Н', close: 'З', volume: 'Об' },
    table: {
      time: 'Време',
      open: 'Отваряне',
      high: 'Най-висока',
      low: 'Най-ниска',
      close: 'Затваряне',
      volume: 'Обем',
    },
    footnote: 'Цени от Yahoo Finance със закъснение около 15 минути. Часове в {{zone}}.',
    attribution: 'Графики от',
    attributionLink: 'TradingView Lightweight Charts™',
    editTitle: 'Символи на графиките',
    editDescription:
      'Произволни символи от Yahoo Finance, отделно от списъка за наблюдение. Плъзнете, за да ги подредите; първият е първи в таблото.',
    symbol: 'Символ',
    symbolPlaceholder: 'напр. ^GDAXI',
    add: 'Добави',
    count: '{{count}} от {{max}} графики',
    full: 'Таблото побира до {{max}} графики.',
    duplicate: '{{symbol}} вече е в таблото.',
    emptyList: 'Няма символи. Добавете отгоре.',
    listLabel: 'Графики в таблото',
    move: 'Премести {{symbol}}',
    remove: 'Премахни {{symbol}}',
    dragInstructions:
      'За да подредите, натиснете интервал, преместете със стрелките, после интервал, за да пуснете, или Escape, за да отмените.',
    pickedUp: '{{symbol}} е вдигнат, позиция {{position}} от {{total}}.',
    movedTo: '{{symbol}} е преместен на позиция {{position}} от {{total}}.',
    dropped: '{{symbol}} е пуснат на позиция {{position}} от {{total}}.',
    cancelled: 'Преместването на {{symbol}} е отменено.',
  },
  watchlist: {
    add: 'Добави инструмент',
    addTitle: 'Добавяне на инструмент',
    addDescription: 'ETF, листван в Европа и търгуван в евро на Xetra.',
    isin: 'ISIN',
    isinHint: 'Например IE00B5BMR087.',
    symbol: 'Символ',
    symbolHint: 'Символът в Yahoo, например SXR8.DE.',
    name: 'Име',
    signal: 'Сигнален символ',
    signalHint:
      'Режимът и историята идват от този символ, например ^GSPC. По подразбиране е самият инструмент.',
    tick: 'Ценова стъпка',
    fractional: 'Части от дял',
    fractionalHint: 'Брокерът ви позволява да купувате части от дял.',
    last: 'Последна',
    day: 'Ден',
    drawdown: 'От върха',
    trend: 'Тренд',
    volatility: 'Волатилност',
    inactive: 'Неактивен',
    activate: 'Активирай',
    deactivate: 'Деактивирай',
    remove: 'Премахни',
    removeTitle: 'Да се премахне ли {{symbol}}?',
    removeBody: 'Инструменти с позиции не могат да се премахнат; деактивирайте ги.',
    actionsFor: 'Действия за {{symbol}}',
    emptyTitle: 'Списъкът е празен',
    emptyBody: 'Добавете ETF-ите върху S&P 500 и Nasdaq-100, с които търгувате.',
    regimeNote: 'Режимът описва пазара, не го предсказва.',
  },
  settings: {
    notifications: 'Известия',
    email: 'Имейл',
    emailHint: 'Къде отиват сигналите.',
    emailInvalid: 'Въведете валиден имейл адрес.',
    sendTest: 'Изпрати тестов имейл',
    testSent: 'Тестовият имейл до {{email}} е на опашката.',
    marketOpenEmail: 'Имейл при отваряне',
    marketOpenHint: 'Когато Xetra отвори и няма отворена позиция.',
    regimeEmails: 'Имейли за режима',
    regimeHint: 'Когато трендът на наблюдаван индекс се обърне.',
    reminderDays: 'Напомняне след',
    reminderHint: 'Ако по сигнал не е предприето действие. Най-много две напомняния.',
    sessions_one: '{{count}} сесия',
    sessions_other: '{{count}} сесии',
    defaults: 'Стойности по подразбиране за нови позиции',
    appearance: 'Изглед',
    languageHint: 'Използва се и в имейлите.',
    region: 'Регион',
    timezone: 'Часова зона',
    timezoneHint: 'За датите в имейлите и статистиката.',
    system: 'Система',
    dataFreshness: 'Пазарни данни',
    lastQuote: 'Последна котировка {{time}}',
    noQuotes: 'Още няма котировки',
    emailDelivery: 'Доставка на имейли',
    outbox: '{{pending}} чакат · {{failed}} неуспешни',
    neverRan: 'Не е стартирала',
    jobStatus: {
      ok: 'Наред',
      failed: 'Неуспешна',
      running: 'Работи',
    },
    saved: 'Настройките са запазени.',
  },
  preferences: {
    menu: 'Предпочитания',
    theme: 'Тема',
    language: 'Език',
    themes: {
      system: 'Системна',
      dark: 'Тъмна',
      light: 'Светла',
    },
  },
  palette: {
    title: 'Команди',
    placeholder: 'Въведете команда или търсене…',
    empty: 'Няма резултати.',
    actions: 'Действия',
    navigation: 'Отиди на',
    positions: 'Позиции',
    preferences: 'Предпочитания',
    newPosition: 'Нова позиция',
    recordFill: 'Запиши покупка · {{symbol}} ниво {{n}}',
    addInstrument: 'Добави инструмент',
    editCharts: 'Редактирай символите на графиките',
    goTo: 'Отиди на {{page}}',
    openPosition: 'Отвори {{symbol}} №{{id}}',
    theme: 'Тема: {{theme}}',
    language: 'Език: {{language}}',
    shortcuts: 'Клавишни комбинации',
  },
  shortcuts: {
    title: 'Клавишни комбинации',
    groups: {
      general: 'Общи',
      navigation: 'Навигация',
      positions: 'Позиции',
    },
    items: {
      palette: 'Команди',
      help: 'Клавишни комбинации',
      newPosition: 'Нова позиция',
      goPositions: 'Към позициите',
      goAlerts: 'Към сигналите',
      goStats: 'Към статистиката',
      goCharts: 'Към графиките',
      goWatchlist: 'Към списъка за наблюдение',
      goSettings: 'Към настройките',
      next: 'Следваща позиция',
      previous: 'Предишна позиция',
      open: 'Отвори позицията',
      recordFill: 'Запиши покупка',
      toggleSidebar: 'Страничен панел',
      toggleInspector: 'Панел с детайли',
      submit: 'Потвърди диалога',
      close: 'Затвори или откажи',
    },
  },
  notFound: {
    title: 'Страницата не е намерена',
    body: 'Връзката може да е стара. Върнете се към позициите.',
    back: 'Към позициите',
  },
};
